import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import {
  EnseignesSearchBar,
  CandidatsSearchBar,
  LocationsSearchBar,
  VillesSearchBar,
} from "@appComponents";

const SEARCH_BARS = {
  enseignes: EnseignesSearchBar,
  candidats: CandidatsSearchBar,
  locations: LocationsSearchBar,
  villes: VillesSearchBar,
};

const STORAGE_KEY = "selectedEnseignes";
const SELECTED_CLASSES = [
  "!bg-default-500",
  "!text-white",
  "[&>svg]:inline-block",
];

export default class extends Controller {
  static targets = ["toolbar"];
  static values = {
    selectedItems: { type: Array, default: [] },
  };

  connect() {
    this.root = createRoot(this.toolbarTarget);
    const savedItems = localStorage.getItem(STORAGE_KEY);
    if (savedItems) {
      this.selectedItemsValue = JSON.parse(savedItems);
      this.initializeSelectedState();
    }
    this.render();
  }

  initializeSelectedState() {
    this.selectedItemsValue.forEach((item) => {
      const checkbox = document.querySelector(
        `[data-searchable-id="${item.id}"]`,
      );
      if (checkbox) {
        checkbox.classList.add(...SELECTED_CLASSES);
      }
    });
  }

  toggleSelection(event) {
    event.preventDefault();
    event.stopPropagation();

    const searchableData = JSON.parse(event.target.dataset.searchable);
    const existingIndex = this.selectedItemsValue.findIndex(
      (selected) => selected.id === searchableData.id,
    );

    let newSelection;
    if (existingIndex === -1) {
      newSelection = [...this.selectedItemsValue, searchableData];
      this.dispatch("selectionAdded", { detail: searchableData });
      event.target.classList.add(...SELECTED_CLASSES);
    } else {
      newSelection = this.selectedItemsValue.filter(
        (selected) => selected.id !== searchableData.id,
      );
      this.dispatch("selectionRemoved", { detail: searchableData });
      event.target.classList.remove(...SELECTED_CLASSES);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(newSelection));
    this.selectedItemsValue = newSelection;
    this.render();
  }

  isSelected(id) {
    return this.selectedItemsValue.some((item) => item.id === id);
  }

  deselectAll() {
    this.selectedItemsValue.forEach((item) => {
      const checkbox = document.querySelector(
        `[data-searchable-id="${item.id}"]`,
      );
      if (checkbox) {
        checkbox.classList.remove(...SELECTED_CLASSES);
      }
    });

    localStorage.removeItem(STORAGE_KEY);
    this.selectedItemsValue = [];
    this.render();
  }

  render() {
    const Component = SEARCH_BARS[this.element.dataset.searchBarType];
    const currentUser = this.element.dataset.currentUser || {
      profileType: "enseigne",
    };

    this.root.render(
      <Component
        currentUser={currentUser}
        selectedItems={this.selectedItemsValue}
        onToggleSelection={(item) => this.toggleSelection({ detail: item })}
        onDeselectAll={() => this.deselectAll()}
      />,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
